import { arrayOf, bool, shape, string, number, oneOfType } from "prop-types";

export const activationPropTypes = shape({
	id: string,
	status: string,
	version: string,
	activated: string,
	deactivated: string,
	computerName: string,
});

export const downloadsPropTypes = shape({
	id: string,
	os: string,
	release: string,
	downloadLink: string,
	releaseDate: string,
	architectures: string,
	minOSVersion: string,
	minOSName: string,
});

export const serialNumbersPropTypes = arrayOf(
	shape({
		serialNumberID: number,
		serialNumber: string,
		licenseName: string,
		activations: arrayOf(activationPropTypes),
		downloads: arrayOf(downloadsPropTypes),
		adminEmails: arrayOf(
			shape({
				id: number,
				adminEmail: string,
			}),
		),
	}),
);

export const paymentMethodPropTypes = shape({
	address1: string,
	address2: string,
	address3: string,
	city: string,
	company: string,
	countryID: number,
	country: shape({
		name: string,
	}),
	email: string,
	firstName: string,
	labName: string,
	lastName: string,
	phone: string,
	require_display_name: bool,
	require_tld: bool,
	state: string,
	zipCode: string,
});

export const subscriptionPropTypes = shape({
	subscriptionID: number,
	expirationDate: string,
	status: string,
	archiveBit: bool,
	serialNumbers: serialNumbersPropTypes,
	plan: shape({
		name: string,
	}),
	paymentMethod: paymentMethodPropTypes,
});

export const perpetualPropTypes = shape({
	serialNumberID: number,
	licenseName: string,
	serialNumber: string,
	product: shape({
		description: string,
	}),
	order: shape({
		orderNumber: number,
		orderDate: string,
	}),
	allowedActivations: number,
	activations: arrayOf(
		shape({
			id: oneOfType([string, number]),
		}),
	),
});
